module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('BaseWidget', [_c('template', {
    slot: "title"
  }, [_vm._v(_vm._s(_vm.$t("dashboardModule.catalogTitle")))]), _vm._v(" "), _c('template', {
    slot: "content-desktop"
  }, _vm._l((_vm.itemList), function(item, index) {
    return _c('ComponentListItem', {
      key: item.id,
      attrs: {
        "page": 'dashboard',
        "index": index,
        "item": item,
        "device": 'desktop'
      }
    })
  })), _vm._v(" "), _c('template', {
    slot: "content-mobile"
  }, [_c('swiper', {
    ref: "mySwiper",
    attrs: {
      "options": _vm.swiperOption
    }
  }, [_vm._l((_vm.itemList), function(item) {
    return _c('swiper-slide', {
      key: item.id,
      staticClass: "txtCenter"
    }, [_c('div', {
      staticClass: "swipe-content"
    }, [_c('router-link', {
      attrs: {
        "to": '/' + item.type + '/' + item.id
      }
    }, [_c('figure', {
      staticClass: "center",
      style: ({
        backgroundImage: 'url(' + _vm.getImgPath(item.figures.big, 'big') + ')'
      })
    }, [(item.figures.big !== null) ? _c('img', {
      staticClass: "hidden",
      attrs: {
        "src": _vm.getImgPath(item.figures.big, 'big'),
        "alt": ""
      }
    }) : _vm._e(), _vm._v(" "), (item.figures.small === null) ? _c('img', {
      staticClass: "ff-medium noPhoto center",
      attrs: {
        "src": require("../../../../static/img/no_image.jpg"),
        "height": "200",
        "width": "200"
      }
    }) : _vm._e()])]), _vm._v(" "), _c('h3', [_c('span', {
      staticClass: "ff-bold"
    }, [_vm._v(_vm._s(_vm.getTranslate(item.terms.name)))])])], 1)])
  }), _vm._v(" "), _c('div', {
    staticClass: "swiper-pagination",
    slot: "pagination"
  })], 2)], 1), _vm._v(" "), _c('template', {
    slot: "footer"
  }, [_c('LinkButton', {
    attrs: {
      "to": '/catalog',
      "text": _vm.$t('dashboardModule.seeAllCat')
    }
  })], 1)], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d4199650","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/dashboard/widgets/CatalogueWidget.vue
// module id = 3376
// module chunks = 0